import React from "react";
import {

  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Home, Info } from "lucide-react";

interface HomeSizeGuideModalProps {
  triggerText?: string;
}

export const HomeSizeGuideModal = ({ triggerText = "Size Guide" }: HomeSizeGuideModalProps) => {
  const guides = [
    { beds: "1 Bedroom / 1 Bath", type: "Apartment / Condo", sqft: "500 - 800 sq ft" },
    { beds: "2 Bedrooms / 1-2 Baths", type: "Small House / Condo", sqft: "800 - 1,200 sq ft" },
    { beds: "3 Bedrooms / 2 Baths", type: "Average House", sqft: "1,200 - 2,000 sq ft" },
    { beds: "4 Bedrooms / 2-3 Baths", type: "Large House", sqft: "2,000 - 3,000 sq ft" },
    { beds: "5+ Bedrooms / 3+ Baths", type: "Estate / Luxury", sqft: "3,000+ sq ft" },
  ];

  return (
    <Dialog>
      <DialogTrigger asChild>
        <button className="text-primary hover:underline inline-flex items-center text-xs font-medium transition-colors">
          <Info className="w-3.5 h-3.5 mr-1" />
          {triggerText}
        </button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md rounded-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-xl">
            <Home className="w-5 h-5 text-primary" />
            Home Size Guide
          </DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <p className="text-sm text-muted-foreground mb-6">
            Not sure about your exact square footage? Use this general guide based on bedroom count to estimate your home's size.
          </p>
          <div className="space-y-3">
            {guides.map((guide, index) => (
              <div key={index} className="flex flex-col sm:flex-row sm:items-center justify-between p-3 rounded-xl bg-muted/30 border border-border/50">
                <div>
                  <p className="font-bold text-sm">{guide.beds}</p>
                  <p className="text-xs text-muted-foreground">{guide.type}</p>
                </div>
                <div className="mt-2 sm:mt-0 bg-primary/10 text-primary px-3 py-1 rounded-full text-sm font-semibold whitespace-nowrap">
                  {guide.sqft}
                </div>
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
